import { showAlert } from "./alerts.js";

console.log("hello from login.js");

const login = async (phone, password) => {
  try {
    const res = await axios.post("/api/v1/users/login", {
      phone,
      password,
    });
    if (res.data.status === "success") {
      showAlert("success", "Success", "Connecté avec succès !");
      await new Promise((resolve) => setTimeout(resolve, 1000));
      location.reload();
    }
  } catch (err) {
    console.log(">>>>>>inside login error : ", err.response.data.message);
    showAlert("danger", "Alert", err.response.data);
  }
};

const signup = async (username, phone) => {
  try {
    const res = await axios.post("/api/v1/users/signup", {
      username,
      phone,
    });
    if (res.data.status === "success") {
      showAlert("success", "Success", "Inscrit avec succès !");
      await new Promise((resolve) => setTimeout(resolve, 1000));
      location.reload(true);
    }
  } catch (err) {
    showAlert("danger", "Alert", err.response.data);
  }
};

const logout = async () => {
  try {
    const res = await axios.get("/api/v1/users/logout");
    if (res.data.status.trim() === "success") {
      showAlert("warning", "Logout", "Déconnecté avec succès");
      await new Promise((resolve) => setTimeout(resolve, 1500));
      location.reload(true);
      location.assign("/");
    }
  } catch (err) {
    showAlert(
      "danger",
      "Alert",
      "Erreur lors de la déconnexion!, Ressayez plus tard.",
    );
  }
};

let logoutBtn = document.getElementById("logoutBtn");
let loginForm = document.getElementById("login-form");
let signupForm = document.getElementById("signup-form");
let storeCheck = document.getElementById("storeCheck");
let storeAdminPwdInput = document.getElementById("login-password");

if (loginForm) {
  loginForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const phone = document.getElementById("login-phone").value;
    const password = document.getElementById("login-password").value;
    login(phone, password);
  });
}

if (signupForm) {
  signupForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const username = document.getElementById("signup-username").value;
    const phone = document.getElementById("signup-phone").value;
    signup(username, phone);
  });
}

// --- API call ---
const signupAsStore = async (formData) => {
  try {
    const res = await axios.post("/api/v1/users/signup-store", formData, {
      headers: { "Content-Type": "application/json" },
    });

    if (res.data.status === "success") {
      showAlert(
        "success",
        "Succès",
        "Boutique créée avec succès. Ajoutez vos produits dès maintenant !",
      );

      // await new Promise((resolve) => setTimeout(resolve, 1500));
      location.assign("/addproduct");
    }
  } catch (err) {
    console.error("Signup store error:", err?.response?.data);

    const message = err?.response?.data?.message || "Une erreur est survenue";

    showAlert("danger", "Erreur", message);

    throw err; // 👈 let caller handle UI reset
  }
};

// --- Helpers ---
const setLoadingState = (btn, isLoading) => {
  if (!btn) return;

  btn.disabled = isLoading;
  btn.innerHTML = isLoading
    ? "<i class='fas fa-spinner fa-spin'></i> &nbsp;Création en cours..."
    : "Créer ma boutique";
};

const getFormData = (form) => {
  const data = {};
  const elements = Array.from(form.elements);

  elements.forEach((el) => {
    if (!el.name) return;

    if (el.type === "checkbox") {
      if (!data[el.name]) data[el.name] = [];
      if (el.checked) data[el.name].push(el.value);
    } else {
      data[el.name] = el.value.trim();
    }
  });

  return data;
};

const validateForm = (data) => {
  if (
    !data.storeName ||
    !data.phone ||
    !data.municipality ||
    !data.password ||
    !data.passwordConfirm
  ) {
    return "Veuillez remplir tous les champs obligatoires (*).";
  }

  if (data.password.length < 4) {
    return "Le mot de passe doit comporter au moins 4 caractères.";
  }

  if (data.password !== data.passwordConfirm) {
    return "Les mots de passe ne correspondent pas.";
  }

  return null;
};

// --- Event ---
const signupStoreForm = document.getElementById("signup-store-form");

if (signupStoreForm) {
  signupStoreForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const submitBtn = document.getElementById("signUpAsStoreSubmitBtn");
    setLoadingState(submitBtn, true);

    try {
      const formData = getFormData(signupStoreForm);

      const error = validateForm(formData);
      if (error) {
        showAlert("danger", "Erreur", error);
        return;
      }

      showAlert("info", "Veuillez patienter", "Création de votre boutique...");
      await signupAsStore(formData);
    } catch (err) {
      // already handled in API
    } finally {
      setLoadingState(submitBtn, false); // ✅ always reset
    }
  });
}

if (logoutBtn) {
  logoutBtn.addEventListener("click", logout);
}

if (storeCheck) {
  storeCheck.addEventListener("click", () => {
    if (storeCheck.checked) {
      storeAdminPwdInput.removeAttribute("disabled");
    } else {
      storeAdminPwdInput.setAttribute("disabled", "disabled");
    }
  });
}

function closeModal($el) {
  $el.classList.remove("is-active");
}

function closeAllModals() {
  Array.from(document.querySelectorAll(".modal")).forEach(($modal) => {
    closeModal($modal);
  });
}

document
  .getElementById("modalRegisterBtn")
  .addEventListener("click", function (e) {
    e.preventDefault();
    closeAllModals();
    document.getElementById("sign").click();
  });

document.getElementById("modalSignBtn").addEventListener("click", function (e) {
  e.preventDefault();
  closeAllModals();

  // document.getElementById("register").click();
});
